import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import {
  getHandlingFeesByID,
  updateHandlingFees,
} from "./services/adminsetting.services";
import ShadowCard from "../../components/common/ShadowCard";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { GSTPERARRAY } from "../../_contstants/common";
import { TfiArrowCircleDown } from "react-icons/tfi";
import FormRichTextField from "../../components/formFields/FormRichTextField";

const AdminSetting: React.FC = () => {
  // const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const [handlingFeeOpen, setHandlingFeeOpen] = useState(true);

  const [formKey, setFormKey] = React.useState(1);

  const loading = useAppSelector((state) => state.adminsetting.loading);
  const addminsettingdetails = useAppSelector(
    (state) => state.adminsetting.addminsettingdetails
  );

  useEffect(() => {
    dispatch(getHandlingFeesByID());
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [addminsettingdetails]);

  const handleSubmit = async (values: any) => {
    try {
      const payload = {
        // ID: null,
        International_Cancellation_Fee: values.International_Cancellation_Fee,
        International_Conv_Fee: values.International_Conv_Fee,
        Domestic_Cancellation_Fee: values.Domestic_Cancellation_Fee,
        Domestic_Conv_Fee: values.Domestic_Conv_Fee,
        Domestic_Remarks: values.Domestic_Remarks,
        International_Remarks: values.International_Remarks,
        GSTPer: values.GSTPer,
        // IsActive: values.IsActive === 1,
      };
      const response = await dispatch(updateHandlingFees(payload));
      if (response?.meta?.requestStatus === "fulfilled") {
        dispatch(getHandlingFeesByID());
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={addminsettingdetails}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <Typography.h4>{"Admin Setting"}</Typography.h4>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                ]}
              >
                <GridLayoutItem colSpan={3}>
                  <Typography.h5
                    style={{
                      marginBottom: "6px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    onClick={() => setHandlingFeeOpen(!handlingFeeOpen)}
                  >
                    {"Handling fees"}
                    <TfiArrowCircleDown
                      className="me-2 chevron-icon"
                      style={{
                        transform: handlingFeeOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </Typography.h5>
                </GridLayoutItem>
                {handlingFeeOpen && (
                  <>
                    <GridLayoutItem>
                      <Field
                        name="Domestic_Conv_Fee"
                        maxLength="100"
                        label="Domestic Conv Fee"
                        placeholder="i.e 250"
                        component={FormTextField}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="International_Conv_Fee"
                        maxLength="100"
                        label="International Conv Fee"
                        placeholder="i.e 500"
                        component={FormTextField}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="Domestic_Cancellation_Fee"
                        maxLength="100"
                        label="Domestic Cancellation Fee"
                        placeholder="i.e 200"
                        component={FormTextField}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="International_Cancellation_Fee"
                        maxLength="100"
                        label="International Cancellation Fee"
                        placeholder="i.e 500"
                        component={FormTextField}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="Domestic_Remarks"
                        label="Domestic Quote Terms & Condition"
                        component={FormRichTextField}
                        contentHeight={250}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="International_Remarks"
                        label="International Quote Terms & Condition"
                        component={FormRichTextField}
                        contentHeight={250}
                        astrike={true}
                        validator={requiredValidator}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem></GridLayoutItem>
                    <GridLayoutItem>
                      <Field
                        name="GSTPer"
                        label="GST Percentage"
                        component={FormSelectionField}
                        validator={requiredValidator}
                        astrike={true}
                        options={GSTPERARRAY?.map((gst: any) => {
                          return {
                            value: gst?.value,
                            label: gst?.label,
                          };
                        })}
                      />
                    </GridLayoutItem>
                    <GridLayoutItem
                      colSpan={1}
                      style={{
                        textAlign: "end",
                        marginTop: "36px",
                        width: "100%",
                      }}
                    >
                      <Button
                        type="button"
                        fillMode={"outline"}
                        themeColor={"primary"}
                        style={{ marginRight: 4 }}
                        onClick={() => setHandlingFeeOpen(false)}
                      >
                        Cancel
                      </Button>
                      <ButtonWithLoading
                        label={"Save"}
                        type="submit"
                        disabled={!formRenderProps.allowSubmit || loading}
                        loading={loading}
                      />
                    </GridLayoutItem>
                    {/* <GridLayoutItem>
                      <Field
                        id={"IsActive"}
                        name={"IsActive"}
                        component={FormSelectionField}
                        label={"Status"}
                        options={STATUSARRAY?.map((status: any) => {
                          return {
                            value: status.value,
                            label: status.label,
                          };
                        })}
                      />
                    </GridLayoutItem> */}
                  </>
                )}
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default AdminSetting;
